import { difference, isEmpty, uniqBy } from 'lodash'
import { TESTING_SITES } from '~/constants/checkoutConstants'
import { getProductPriceCents } from '../Services/prices'

const SET_BASE_PRODUCT = 'SET_BASE_PRODUCT'
const ADD_PRODUCT = 'ADD_PRODUCT'
const REMOVE_PRODUCT = 'REMOVE_PRODUCT'
const SET_SUBSCRIPTION_INTERVAL = 'SET_SUBSCRIPTION_INTERVAL'
const SET_TO_INITIAL = 'SET_TO_INITIAL'
const SET_TESTING_SITE = 'SET_TESTING_SITE'
const SET_PRESELECTED = 'SET_PRESELECTED'

export default {
  namespaced: true,

  state: () => ({
    baseProduct: {},
    products: [],
    subscriptionInterval: 6,
    // paymentMethod: null,
    testingSite: TESTING_SITES.CLINIC,
    preselected: []
  }),

  mutations: {
    [SET_BASE_PRODUCT](state, value) {
      state.baseProduct = value
    },
    [ADD_PRODUCT](state, product) {
      state.products.push(product)
    },
    [REMOVE_PRODUCT](state, product) {
      const index = state.products.findIndex((i) => i.id === product.id)
      state.products.splice(index, 1)
    },
    [SET_SUBSCRIPTION_INTERVAL](state, value) {
      state.subscriptionInterval = value
    },
    [SET_TO_INITIAL](state) {
      state.baseProduct = {}
      state.products = []
      state.subscriptionInterval = 6
    },
    [SET_TESTING_SITE](state, value) {
      state.testingSite = value
    },
    [SET_PRESELECTED](state, value) {
      state.preselected = value
    }
  },

  getters: {
    isSelectedProduct: (state) => (id) =>
      state.products.findIndex((i) => i.id === id) > -1,
    getAllProducts: (state) => [state.baseProduct, ...state.products],
    getProductTests: (state) => {
      const tests = []
      for (let i = 0; i < state.products.length; i++) {
        const prod = state.products[i]
        tests.push(...prod.biomarkers)
      }
      return tests
    },
    getBaseProductPrice: (state) => {
      return getProductPriceCents(state.baseProduct, state.subscriptionInterval)
    },
    getTotalPrice: (state, getters) => {
      let sum = 0
      state.products.forEach((product) => {
        const amount = getProductPriceCents(product, state.subscriptionInterval)
        sum += amount
      })
      return sum + getters.getBaseProductPrice
    },
    getFinalPrice: (state, getters) =>
      getters.getTotalPrice - getters.getDuplicatedTestsPrice,
    getDuplicatedTests: (state, getters) => {
      if (getters.getProductTests) {
        return difference(
          getters.getProductTests,
          uniqBy(getters.getProductTests, 'id'),
          'id'
        )
      }
      return []
    },
    selectedProductsHasMatchingTest: (state, getters) =>
      !isEmpty(getters.getDuplicatedTests),
    getDuplicatedTestsPrice: (state, getters) => {
      if (!isEmpty(getters.getDuplicatedTests)) {
        let sum = 0
        for (let i = 0; i < getters.getDuplicatedTests.length; i++) {
          const prices = getters.getDuplicatedTests[i].retail_prices
          sum += prices ? parseFloat(prices[state.subscriptionInterval]) : 0
        }
        return sum
      }
      return 0
    }
  },

  actions: {
    addBaseProduct({ commit }, value) {
      commit(SET_BASE_PRODUCT, value)
    },
    addProduct({ commit }, product) {
      commit(ADD_PRODUCT, product)
    },
    removeProduct({ commit }, product) {
      commit(REMOVE_PRODUCT, product)
    },
    setSubscriptionInterval({ commit }, value) {
      commit(SET_SUBSCRIPTION_INTERVAL, value)
    },
    setStateToInitial({ commit }) {
      commit(SET_TO_INITIAL)
    },
    setTestingSite({ commit }, value) {
      commit(SET_TESTING_SITE, value)
    },
    setPreselected({ commit }, value) {
      commit(SET_PRESELECTED, value)
    }
  }
}
